import React from "react";
import { Trash2, Archive, RotateCcw } from "lucide-react";
import { Button } from "../../../components/ui/button";

export function TestPlanBulkBar({
  selectedCount,
  onBulkDelete,
  onBulkArchive,
  onBulkRestore,
  disabled,
}) {
  const inactive = selectedCount === 0 || disabled;

  return (
    <div
      className="flex flex-wrap items-center gap-2 border-b border-gray-200 pb-4"
      data-testid="test-plan-bulk-bar"
    >
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={inactive}
        onClick={onBulkDelete}
        className="border-rose-200 text-rose-700 hover:bg-rose-50 disabled:opacity-40"
      >
        <Trash2 className="mr-2 h-4 w-4" />
        Delete
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={inactive}
        onClick={onBulkArchive}
        className="border-gray-300 text-gray-800 hover:bg-gray-50 disabled:opacity-40"
      >
        <Archive className="mr-2 h-4 w-4" />
        Archive
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={inactive}
        onClick={onBulkRestore}
        className="border-amber-200 text-amber-900 hover:bg-amber-50 disabled:opacity-40"
      >
        <RotateCcw className="mr-2 h-4 w-4" />
        Restore
      </Button>
      {selectedCount > 0 && (
        <span className="text-sm text-text-secondary">
          {selectedCount} selected
        </span>
      )}
    </div>
  );
}
